import { groupByDate } from './dateSeparate';
import { groupByType } from './typeSeparate';
import { removeEmpty } from './objectMutations';

const currencyFormat = (num: number) => {
  return '£' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '£1,');
};

export { groupByType, groupByDate, removeEmpty, currencyFormat };
